import { isLogRocketEnabled, ROCKET_ID, WEB_VERSION } from 'config';
import LogRocket from 'logrocket';
import { useEffect } from 'react';
import { SessionService } from 'services';

let isLogRocketInitialized = false;

export const initializeLogRocket = () => {
  const currentUser =
    SessionService.getUser() && SessionService.getToken()
      ? SessionService.getUser()?.email
      : undefined;

  if (isLogRocketEnabled && currentUser && !isLogRocketInitialized) {
    isLogRocketInitialized = true;
    LogRocket.init(ROCKET_ID, {
      release: WEB_VERSION,
      console: {
        shouldAggregateConsoleErrors: false,
      },
    });
  }
};

export function useLogRocket() {
  const currentUser =
    SessionService.getUser() && SessionService.getToken()
      ? SessionService.getUser()?.email
      : undefined;

  useEffect(() => {
    initializeLogRocket();
  }, [currentUser]);

  return void 0;
}
